const $hamburger = $('.header_mobile-hamburger');

export function initHamburger() {
	$hamburger.on('click', function() {
		$(this).toggleClass('hamburger--active');
	})
} 


// WEBPACK FOOTER //
// ./scripts/components/hamburger.ts